import { ReactComponent as TiktokSocial } from "assets/images/tiktokSocial.svg";
import { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { usePrivy, useWallets } from "@privy-io/react-auth";
import { parseEther } from "@ethersproject/units";
import { useAuth } from "contexts/authContext";
import { appConfig } from "services/blockchain";

const MIN_BALANCE = "0.01";
const PORTAL_BASE_ETH_MAINNET = "0x49048044D57e1C92A77f79988d21Fa8fAF74E97e";

function AccountVerify() {
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(false);

  const { updateIsDepositEth, updateIsBuyFirstShares } = useAuth();

  const { wallets } = useWallets();
  const embeddedWallet = wallets.find(
    (wallet) => wallet.walletClientType === "privy"
  );

  const [isCopied, setIsCopied] = useState(false);

  const truncatedAddress =
    embeddedWallet?.address &&
    `${embeddedWallet?.address.slice(0, 12)}...${embeddedWallet?.address.slice(
      -12
    )}`;

  const handleBridge = async () => {
    // if (!embeddedWallet) return;
    // setProcessing(true);
    // try {
    //   const provider = await embeddedWallet.getEthersProvider();
    //   const balance = await provider.getBalance(embeddedWallet?.address);
    //   if (balance.gte(parseEther(MIN_BALANCE))) {
    //     await sendTransaction(unsignedTx, uiConfig);
    //     await embeddedWallet.switchChain(8453); // Switch to base
    //     const providerBase = await embeddedWallet.getEthersProvider();
    //     const fetchBaseBalanceInterval = setInterval(async () => {
    //       const balance = await providerBase.getBalance(
    //         embeddedWallet?.address
    //       );
    //       if (balance.gte(parseEther(MIN_BALANCE))) {
    //         clearInterval(fetchBaseBalanceInterval);
    //         setProcessing(false);
    //         updateIsDepositEth("IsDepositedEth");
    //       }
    //     }, 1000);
    //   }
    // } catch (error) {
    //   console.log(
    //     "🚀 ~ file: DepositEth.tsx:41 ~ handleCheckBalance ~ error:",
    //     error
    //   );
    //   setProcessing(false);
    // }
  };

  const handleProcess = async () => {
    try {
      if (!embeddedWallet) return;
      setProcessing(true);
      const balance = await appConfig.provider.getBalance(
        embeddedWallet?.address
      );
      console.log(
        "🚀 ~ file: DepositEth.tsx:73 ~ fetchBaseBalanceInterval ~ balance:",
        balance
      );

      if (balance.gte(parseEther(MIN_BALANCE))) {
        updateIsDepositEth("IsDepositedEth");
        setProcessing(false);
        setError(false);
      } else {
        setError(true);
        setProcessing(false);
      }
    } catch (error) {
      console.log(
        "🚀 ~ file: DepositEth.tsx:70 ~ handleProcess ~ error:",
        error
      );
    }
  };

  const { sendTransaction } = usePrivy();

  const unsignedTx = {
    to: PORTAL_BASE_ETH_MAINNET,
    chainId: 1,
    value: parseEther(MIN_BALANCE).toHexString(),
  };

  // Replace this with the text you'd like on your transaction modal
  const uiConfig = {
    header: "Bridge your asset to Base",
    description: "Bridge your asset to Base",
    buttonText: "Bridge",
  };

  // useEffect(() => {
  //   const checkBalanceBase = async () => {
  //     if (!embeddedWallet) return;
  //     await embeddedWallet.switchChain(8453); // Switch to base
  //     const providerBase = await embeddedWallet.getEthersProvider();
  //     const balance = await providerBase.getBalance(embeddedWallet?.address);
  //     if (balance.gte(parseEther(MIN_BALANCE))) {
  //           updateIsDepositEth("IsDepositedEth");
  //     }
  //   };
  //   checkBalanceBase();
  // }, [embeddedWallet, navigate]);

  return (
    <div className="flex-1 flex flex-col justify-between w-full h-full p-4">
      {/* <button onClick={handleTxn}>Sent txn</button> */}

      <div className="flex flex-col gap-6">
        <TiktokSocial className="w-24" />
        <div className="flex flex-col gap-4 text-sm text-slate-300">
          <h2 className="text-2xl text-white">Deposit ETH</h2>
          <p className="">You’ll use ETH to buy/sell your idols’s shares.</p>

          {/* <p>
            Send min 0.05 ETH (Ethereum) to the wallet below. Fan.tech will
            automatically bridge to BASE for you.
          </p> */}

          <p>Send min {MIN_BALANCE} ETH (Base) to the wallet below.</p>
        </div>
        <div className="mt-2 flex items-end justify-between w-full py-4 px-[14px] border-2 border-slate-700 bg-transparent rounded-xl focus:outline-none text-slate-300 text-sm">
          <div>
            <div className="text text-lg text-white">Your wallet address</div>
            <div className="text">{truncatedAddress}</div>
          </div>
          <div className="flex justify-end">
            <CopyToClipboard
              text={embeddedWallet?.address!}
              onCopy={() => {
                setIsCopied(true);
              }}
            >
              <button
                className={`text-sm flex gap-1 text-[#EC53B0]`}
                disabled={false} //TODO:
              >
                {isCopied ? "Copied" : "Copy Address"}
              </button>
            </CopyToClipboard>
          </div>
        </div>
        {error ? (
          <div className="text-xs mb-6 -mt-2">
            <p className="text-warning">
              <i className="fa-solid fa-circle-exclamation mr-2"></i>
              You need at least 0.01 ETH (Base) on your wallet to continue.
            </p>
          </div>
        ) : null}{" "}
      </div>

      <div className="flex gap-2 w-full">
        <button
          className="rounded-xl btn flex-1 bg-secondary uppercase"
          onClick={(e) => {
            e.preventDefault();
            handleProcess();
          }}
          disabled={processing || !embeddedWallet?.address}
        >
          {processing ? (
            <span className="flex items-center gap-2">
              <i className="loading w-5"></i> Processing
            </span>
          ) : (
            "Proceed"
          )}
        </button>
        <button
          className="rounded-xl btn btn-outline border-2 border-gray-800  uppercase"
          onClick={(e) => {
            e.preventDefault();
            updateIsDepositEth("IsDepositedEth");
          }}
          disabled={processing || !embeddedWallet?.address}
        >
          Skip
        </button>
      </div>
    </div>
  );
}

export { AccountVerify as default };
